import { useEffect, useState } from "react";
import Select from "react-select";
import { server } from "../../server";
import axios from "axios";
import { toast } from "react-toastify";
import { useLocation, useNavigate } from "react-router-dom";
import BusSeatView from "../../components/BusSeatView";

function UpdateDriver() {
  const [formData, setFormData] = useState({
    driverName: "",
    driverDOB: "",
    driverPhoneNumber: "",
    driverAddress: "",
    driverLicenseNumber: "",
    driverAadhaarNumber: "",
    helperName: "",
    helperPhoneNumber: "",
    busNumber: "",
    vehicleNumber: "",
    licenseCategory: "",
    licenseValidUpto: "",
  });

  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [busDetails, setBusDetails] = useState([]);
  const { state } = useLocation();
  const driverId = state?.driverId;
  const navigate = useNavigate();

  useEffect(() => {
    const fetchDriverDetails = async () => {
      try {
        const response = await axios.post(
          `${server}/driver_details_by_driverId_mongodb`,
          { driverId },
          {
            headers: {
              Authorization: `${localStorage.getItem("token")}`,
              "Content-Type": "application/json",
            },
          },
        );

        const driverDetails = response.data["body-json"]?.body;
        if (!driverDetails) {
          toast.error("Driver Details Not Found");
          return;
        }

        setFormData({
          driverName: driverDetails.driverName || "",
          driverDOB: driverDetails.driverDOB || "",
          driverPhoneNumber: driverDetails.driverPhoneNumber || "",
          driverAddress: driverDetails.driverAddress || "",
          driverLicenseNumber: driverDetails.driverLicenseNumber || "",
          driverAadhaarNumber: driverDetails.driverAadhaarNumber || "",
          helperName: driverDetails.helperName || "",
          helperPhoneNumber: driverDetails.helperPhoneNumber || "",
          busNumber: driverDetails.busNumber || "",
          vehicleNumber: driverDetails.vehicleNumber || "",
          licenseCategory: driverDetails.licenseCategory || "",
          licenseValidUpto: driverDetails.licenseValidUpto || "",
        });
      } catch (error) {
        toast.error("Failed to Fetch Driver Details");
        console.error(error);
      }
    };

    if (driverId) {
      fetchDriverDetails();
    }
  }, [driverId]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    let updatedFormData = { ...formData, [name]: value };

    if (name === "busNumber") {
      const selectedBus = busDetails.find(
        (bus) => bus.generalInfo.busNumber === value,
      );
      updatedFormData.vehicleNumber = selectedBus
        ? selectedBus.generalInfo.vehicleNumber
        : "";
    }

    setFormData(updatedFormData);
    setErrors((prev) => ({ ...prev, [name]: false }));
  };

  const driverFields = [
    "driverName",
    "driverDOB",
    "driverPhoneNumber",
    "driverAddress",
    "driverLicenseNumber",
    "driverAadhaarNumber",
    "helperName",
    "helperPhoneNumber",
    "licenseCategory",
    "licenseValidUpto",
  ];

  const busFields = ["busNumber", "vehicleNumber"];

  const countFilledFields = (fields) => {
    return String(
      fields.filter((field) => formData[field].trim() !== "").length,
    ).padStart(2, "0");
  };

  const getTotalFields = (fields) => {
    return String(fields.length).padStart(2, "0");
  };

  useEffect(() => {
    const fetchBusDetails = async () => {
      try {
        const response = await axios.get(`${server}/allBusDetailsMongoDb`, {
          headers: {
            Authorization: `${localStorage.getItem("token")}`,
          },
        });
        if (response.data && response.data["body-json"]?.body?.data) {
          setBusDetails(response.data["body-json"].body.data);
        } else {
          console.error("Invalid data format from API", response.data);
        }
      } catch (error) {
        console.error("Error fetching bus details:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchBusDetails();
  }, []);

  const handleUpdateDriver = async () => {
    setLoading(true);
    try {
      const payload = {
        ...formData,
        driverId,
      };

      await axios.post(`${server}/update_driver_details_mongodb`, payload, {
        headers: {
          Authorization: `${localStorage.getItem("token")}`,
          "Content-Type": "application/json",
        },
      });

      toast.success("Driver Details Updated");
      navigate("/driver-details");
    } catch (error) {
      toast.error("Failed to update driver details");
      console.error("Update Error:", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <div id="db-wrapper">
        <main id="page-content">
          <div className="">
            <div class="container-fluid">
              <div class="row">
                <div class="col-lg-12 col-md-12 col-12">
                  <div class="m-3 mt-2 pt-1 d-flex justify-content-between">
                    <div class="d-flex align-items-center mt-2">
                      <span
                        onClick={() => window.history.back()}
                        class="back-button me-3 cursor-pointer"
                      >
                        <i className="bi bi-arrow-left fs-3"></i>
                      </span>
                      <nav aria-label="breadcrumb">
                        <h4 className="m-0 lh-sm">Update Driver</h4>
                        <ol class="breadcrumb pe-3 lh-sm">
                          <li class="breadcrumb-item">
                            <a href="#">Transport Management</a>
                          </li>
                          <li class="breadcrumb-item">
                            <a href="#">Driver Details</a>
                          </li>
                          <li
                            class="breadcrumb-item active"
                            aria-current="page"
                          >
                            Update Driver
                          </li>
                        </ol>
                      </nav>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div>
            <div class="container-fluid">
              <div className="row g-2">
                <div className="col-lg-8">
                  <form>
                    <div class="px-5 py-3 bg-white rounded-4">
                      <div
                        class="accordion accordion-flush"
                        id="accordionExample"
                      >
                        <div id="headingOne">
                          <h3 class="m-0 fs-list">
                            <a
                              href="#"
                              class="d-flex align-items-center text-inherit"
                              data-bs-toggle="collapse"
                              data-bs-target="#collapseOne"
                              aria-controls="collapseOne"
                            >
                              <span class="me-auto fs-5">
                                1. Driver Information{" "}
                                <span className="ms-3 text-secondary">
                                  ({countFilledFields(driverFields)}/
                                  {getTotalFields(driverFields)})
                                </span>
                              </span>
                              <div className="d-flex align-items-center">
                                <span class="badge bg-secondary-soft me-3 px-3">
                                  Locked
                                </span>
                                <div class="form-check form-switch me-4">
                                  <input
                                    type="checkbox"
                                    class="form-check-input m-0"
                                    checked
                                  />
                                </div>
                                <span className="collapse-toggle">
                                  <i class="bi bi-chevron-down"></i>
                                </span>
                              </div>
                            </a>
                          </h3>

                          <div
                            id="collapseOne"
                            class="collapse"
                            aria-labelledby="headingOne"
                            data-bs-parent="#accordionExample"
                          >
                            <div className="row g-2 mt-2 mb-3">
                              <div className="col-lg-6 col-12">
                                <label class="form-label mb-1 ms-3">
                                  Driver Name
                                </label>
                                <input
                                  type="text"
                                  className={`form-control text-dark ${
                                    errors?.driverName ? "border-danger" : ""
                                  }`}
                                  name="driverName"
                                  placeholder="Enter Driver Name"
                                  value={formData.driverName}
                                  onChange={handleChange}
                                  required
                                />
                              </div>
                              <div className="col-lg-6 col-12">
                                <label class="form-label mb-1 ms-3">
                                  Driver DOB
                                </label>
                                <input
                                  type="date"
                                  className={`form-control text-dark ${
                                    errors?.driverDOB ? "border-danger" : ""
                                  }`}
                                  name="driverDOB"
                                  placeholder="Enter Driver DOB"
                                  value={formData.driverDOB}
                                  onChange={handleChange}
                                  required
                                />
                              </div>
                              <div className="col-lg-6 col-12">
                                <label class="form-label mb-1 ms-3">
                                  Driver Phone No
                                </label>
                                <input
                                  type="text"
                                  className={`form-control text-dark ${
                                    errors?.driverPhoneNumber
                                      ? "border-danger"
                                      : ""
                                  }`}
                                  name="driverPhoneNumber"
                                  maxLength={10}
                                  placeholder="Enter Driver Phone No"
                                  value={formData.driverPhoneNumber}
                                  onChange={handleChange}
                                  required
                                />
                              </div>
                              <div className="col-lg-6 col-12">
                                <label class="form-label mb-1 ms-3">
                                  Driver Address
                                </label>
                                <textarea
                                  type="text"
                                  className={`form-control text-dark ${
                                    errors?.driverAddress ? "border-danger" : ""
                                  }`}
                                  name="driverAddress"
                                  placeholder="Enter Driver Address"
                                  value={formData.driverAddress}
                                  onChange={handleChange}
                                  rows="4"
                                  required
                                ></textarea>
                              </div>
                              <div className="col-lg-6 col-12">
                                <label class="form-label mb-1 ms-3">
                                  Driver Aadhaar No
                                </label>
                                <input
                                  type="text"
                                  className={`form-control text-dark ${
                                    errors?.driverAadhaarNumber
                                      ? "border-danger"
                                      : ""
                                  }`}
                                  name="driverAadhaarNumber"
                                  maxLength={12}
                                  placeholder="Enter Driver Aadhaar No"
                                  value={formData.driverAadhaarNumber}
                                  onChange={handleChange}
                                  required
                                />
                              </div>
                              <div className="col-lg-6 col-12">
                                <label class="form-label mb-1 ms-3">
                                  Driver License No
                                </label>
                                <input
                                  type="text"
                                  className={`form-control text-dark ${
                                    errors?.driverLicenseNumber
                                      ? "border-danger"
                                      : ""
                                  }`}
                                  name="driverLicenseNumber"
                                  placeholder="Enter Driver License No"
                                  value={formData.driverLicenseNumber}
                                  onChange={handleChange}
                                  required
                                />
                              </div>
                              <div className="col-lg-6 col-12">
                                <label class="form-label mb-1 ms-3">
                                  License Category{" "}
                                  <span className="text-danger">*</span>
                                </label>
                                <Select
                                  name="licenseCategory"
                                  value={
                                    [
                                      "FVG / MCWOG",
                                      "MCWG",
                                      "LMV-NT",
                                      "HGMV",
                                      "HPMV",
                                      "HMV",
                                      "MGV",
                                      "LMV",
                                    ]
                                      .map((cat) => ({
                                        label: cat,
                                        value: cat,
                                      }))
                                      .find(
                                        (opt) =>
                                          opt.value ===
                                          formData.licenseCategory,
                                      ) || null
                                  }
                                  onChange={(selected) =>
                                    handleChange({
                                      target: {
                                        name: "licenseCategory",
                                        value: selected?.value || "",
                                      },
                                    })
                                  }
                                  options={[
                                    "FVG / MCWOG",
                                    "MCWG",
                                    "LMV-NT",
                                    "HGMV",
                                    "HPMV",
                                    "HMV",
                                    "MGV",
                                    "LMV",
                                  ].map((cat) => ({
                                    label: cat,
                                    value: cat,
                                  }))}
                                  placeholder="Select License Category"
                                />
                              </div>
                              <div className="col-lg-6 col-12">
                                <label class="form-label mb-1 ms-3">
                                  License Valid Upto
                                </label>
                                <input
                                  type="date"
                                  className={`form-control text-dark ${
                                    errors?.licenseValidUpto
                                      ? "border-danger"
                                      : ""
                                  }`}
                                  name="licenseValidUpto"
                                  placeholder="Enter License Valid Upto"
                                  value={formData.licenseValidUpto}
                                  onChange={handleChange}
                                  required
                                />
                              </div>
                              <div className="col-lg-6 col-12">
                                <label class="form-label mb-1 ms-3">
                                  Helper Name
                                </label>
                                <input
                                  type="text"
                                  className={`form-control text-dark ${
                                    errors?.helperName ? "border-danger" : ""
                                  }`}
                                  name="helperName"
                                  placeholder="Enter Helper Name"
                                  value={formData.helperName}
                                  onChange={handleChange}
                                />
                              </div>
                              <div className="col-lg-6 col-12">
                                <label class="form-label mb-1 ms-3">
                                  Helper Phone No
                                </label>
                                <input
                                  type="text"
                                  className={`form-control text-dark ${
                                    errors?.helperPhoneNumber
                                      ? "border-danger"
                                      : ""
                                  }`}
                                  name="helperPhoneNumber"
                                  maxLength={10}
                                  placeholder="Enter Helper Phone No"
                                  value={formData.helperPhoneNumber}
                                  onChange={handleChange}
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="px-5 py-3 mt-1 bg-white rounded-4">
                      <div
                        class="accordion accordion-flush"
                        id="accordionExample"
                      >
                        <div id="headingTwo">
                          <h3 class="m-0 fs-list">
                            <a
                              href="#"
                              class="d-flex align-items-center text-inherit"
                              data-bs-toggle="collapse"
                              data-bs-target="#collapseTwo"
                              aria-controls="collapseTwo"
                            >
                              <span class="me-auto fs-5">
                                2. Bus Details{" "}
                                <span className="ms-3 text-secondary">
                                  ({countFilledFields(busFields)}/
                                  {getTotalFields(busFields)})
                                </span>
                              </span>
                              <div className="d-flex align-items-center">
                                <span class="badge bg-secondary-soft me-3 px-3">
                                  Locked
                                </span>
                                <div class="form-check form-switch me-4">
                                  <input
                                    type="checkbox"
                                    class="form-check-input m-0"
                                    checked
                                  />
                                </div>
                                <span className="collapse-toggle">
                                  <i class="bi bi-chevron-down"></i>
                                </span>
                              </div>
                            </a>
                          </h3>

                          <div
                            id="collapseTwo"
                            class="collapse"
                            aria-labelledby="headingTwo"
                            data-bs-parent="#accordionExample"
                          >
                            <div className="row g-2 mt-2 mb-3">
                              <div className="col-lg-6 col-12">
                                <label class="form-label mb-1 ms-3">
                                  Bus No <span className="text-danger">*</span>
                                </label>
                                <Select
                                  name="busNumber"
                                  value={
                                    busDetails
                                      .map((bus) => ({
                                        label: bus.generalInfo.busNumber,
                                        value: bus.generalInfo.busNumber,
                                      }))
                                      .sort(
                                        (a, b) =>
                                          parseInt(a.value) - parseInt(b.value),
                                      )
                                      .find(
                                        (opt) =>
                                          opt.value === formData.busNumber,
                                      ) || null
                                  }
                                  onChange={(selected) =>
                                    handleChange({
                                      target: {
                                        name: "busNumber",
                                        value: selected?.value || "",
                                      },
                                    })
                                  }
                                  options={busDetails
                                    .map((bus) => ({
                                      label: bus.generalInfo.busNumber,
                                      value: bus.generalInfo.busNumber,
                                    }))
                                    .sort(
                                      (a, b) =>
                                        parseInt(a.value) - parseInt(b.value),
                                    )}
                                  placeholder="Select Bus Number"
                                />
                              </div>
                              <div className="col-lg-6 col-12">
                                <label class="form-label mb-1 ms-3">
                                  Vehicle No{" "}
                                  <span className="text-danger">*</span>
                                </label>
                                <input
                                  type="text"
                                  className={`form-control text-dark ${
                                    errors?.vehicleNumber ? "border-danger" : ""
                                  }`}
                                  name="vehicleNumber"
                                  value={formData.vehicleNumber}
                                  readOnly
                                />
                              </div>

                              {formData.vehicleNumber && (
                                <BusSeatView
                                  vehicleNumber={formData.vehicleNumber}
                                />
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="my-3 d-flex float-end me-5">
                      <button
                        onClick={handleUpdateDriver}
                        disabled={loading}
                        class="btn btn-success mt-2 px-6"
                      >
                        {loading ? (
                          <div
                            class="spinner-border spinner-border-sm"
                            role="status"
                          ></div>
                        ) : (
                          "Submit"
                        )}
                      </button>
                    </div>
                  </form>
                </div>

                <div className="col-lg-4">
                  <div class="p-5 bg-white rounded-4 sticky-top top-10 z-1">
                    <div className="d-flex flex-column align-items-center">
                      <div>
                        <div class="icon-shape icon-xxl p-7 border rounded-3 position-relative me-2">
                          <span class="position-absolute mt-2">
                            <i class="bi bi-image fs-2"></i>
                          </span>
                          <input
                            class="form-control border-0 opacity-0"
                            type="file"
                          />
                        </div>
                        <div class="icon-shape icon-xxl p-7 border rounded-3 position-relative">
                          <img
                            src="https://cdn-icons-png.flaticon.com/512/14021/14021384.png"
                            className="w-100 position-absolute p-2 rounded-4"
                            alt="QR"
                          />
                        </div>
                      </div>
                      <div className="mt-3 text-center">
                        <h3 class="m-0 fs-4 lh-sm">ARUN PANDEY</h3>
                        <p className="m-0 lh-sm">
                          Bus No. 10 <br /> JH01FA4500
                        </p>
                        <p className="mt-2 mb-0 text-danger lh-sm">
                          (+91) 6203788544
                        </p>

                        <div className="mt-4">
                          <a
                            href="#"
                            class="btn btn-danger btn-sm px-4 rounded-3 px-3"
                          >
                            <i className="bi bi-trash me-1"></i> Delete Driver
                          </a>
                        </div>

                        <p className="m-0 lh-sm mt-4 text-capitalize">
                          VILL SINDRI (SONDAG) ARKI KHUNTI, KOCHASINDRI -
                          834001, JHARKHAND
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </main>
      </div>
    </>
  );
}

export default UpdateDriver;
